class FreeEngraving extends HTMLElement {
  constructor() {
    super();
    this.freeEngravingData = this.getFreeEngravingData();
  }

  connectedCallback() {
    this.initElements();
    this.loadEventListeners();
    this.loadModalWithProductData();
  }

  disconnectedCallback() { }

  initElements() {
    this.modalTitle = this.querySelector("header h2");
    this.closeBtn = this.querySelector("#free-engraving--close");
    this.openModalBtn = document.querySelector("#main-product--free-engraving");

    this.engravingPreviewImg = this.querySelector(
      "#free-engraving--preview-img"
    );
    this.engravingPreviewTextLine1 = this.querySelector(
      "#free-engraving--preview-message-line1"
    );
    this.engravingPreviewTextLine2 = this.querySelector(
      "#free-engraving--preview-message-line2"
    );

    this.form = this.querySelector("form");
    this.inputVariantId = this.form.querySelector(
      "#engraving_service_variant_id"
    );
    this.skipEngraving = this.querySelector("#skip-free-engraving");

    /** Get PDP product form component */
    this.productForm = document.querySelector("product-form");

    /** Get cart drawer component */
    this.cart = document.querySelector("cart-drawer");
  }

  loadEventListeners() {
    this.closeBtn.addEventListener("click", (e) => {
      if (!e.target.closest("#free-engraving--close")) return;
      this.toggleModal(false);
    });

    this.openModalBtn?.addEventListener("click", (e) => {
      if (!e.target.closest("#main-product--free-engraving")) return;
      this.toggleModal(true);
    });

    this.form.addEventListener("submit", this.submitEventHandler.bind(this));

    this.form.addEventListener("input", (event) => {
      if (event.target.name === '_Line1') {
        this.updateEngravingPreviewMessage(event.target.value, 'line1');
      } else if (event.target.name === '_Line2') {
        this.updateEngravingPreviewMessage(event.target.value, 'line2');
      }
    });


    this.skipEngraving.addEventListener("click", (e) => {
      if (!e.target.closest("#skip-free-engraving")) return;
      this.productForm.querySelector(`button[type="submit"]`).click();
      this.toggleModal(false);
    });
  }

  loadModalWithProductData() {
    if (!this.freeEngravingData.currentProductId) return;
    const [data] = this.freeEngravingData.services.filter((item) =>
      item.associatedProducts.includes(this.freeEngravingData.currentProductId)
    );

    if (!data) return;
    this.modalTitle.innerHTML = data.title;
    this.inputVariantId.value = `gid://shopify/ProductVariant/${data.engravingId}`;
    this.engravingPreviewImg.setAttribute("src", data.previewImage.url);
    this.engravingPreviewImg.setAttribute("width", data.previewImage.width);
    this.engravingPreviewImg.setAttribute("height", data.previewImage.height);
    const isMobile = window.innerWidth <= 768;
    const verticalAlignment = isMobile ? data.engraving_text_vertical_alignment + 13 : data.engraving_text_vertical_alignment;
    this.engravingPreviewTextLine1.style.top = `${verticalAlignment}%`;
    this.engravingPreviewTextLine2.style.top = `${verticalAlignment + 5}%`;

    this.openModalBtn.style.display = "block";

    this.productForm.querySelector(`button[type="submit"]`).style.display =
      "none";
  }

  submitEventHandler(event) {
    event.preventDefault();
    let form = new FormData(this.form);
    let formData = Object.fromEntries(form.entries());
    let data = {
      id: this.getWatchVariantId(),
      quantity: 1,
      properties: {
        ...formData,
      },
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };
    this.addProductAndEngraving(data);
  }

  async addProductAndEngraving(data) {
    this.form.querySelector("button").disabled = true;
    try {
      // Send request
      const request = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      // Await the request response
      const response = await request.json();

      // Render the cart drawer with the response
      this.renderCartDrawer(response);

      // Hide engraving modal
      this.toggleModal(false);
    } catch (error) {
      // Print error in the console
      console.log(`❌ Engraving Error | ${error}`);
    } finally {
      // Enable the addWatchAndEngravingBtn button
      this.form.querySelector("button").disabled = true;
    }
  }

  getWatchVariantId() {
    return this.productForm?.querySelector('input[name="id"]').value;
  }

  updateEngravingPreviewMessage(value, line) {
    if (line === 'line1') {
      // Update the first line preview
      this.engravingPreviewTextLine1.innerHTML = value === "" ? "Engraving Message" : value;
    } else if (line === 'line2') {
      if (this.engravingPreviewTextLine2) {
        this.engravingPreviewTextLine2.innerHTML = value;
      }
    }
  }


  getFreeEngravingData() {
    return JSON.parse(this.querySelector("#free-engraving-data").textContent);
  }

  toggleModal(flag) {
    this.querySelector(
      "#free-engraving--modal"
    ).dataset.showFreeEngravingModal = flag;
  }

  renderCartDrawer(response) {
    const { sections } = response;

    const parsedResponse = {
      id: response.id,
      sections,
    };

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "engraving-form",
      productVariantId: parsedResponse.id,
      cartData: parsedResponse,
    });

    this.cart.renderContents(parsedResponse);

    if (this.cart && this.cart.classList.contains("is-empty"))
      this.cart.classList.remove("is-empty");
  }
}
customElements.define("free-engraving", FreeEngraving);
